<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      hide-actions
      :loading="loadingInProgress"
      :no-data-text="loadingItemsText"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ formName }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td>
          <v-tooltip top>
            <v-btn
              slot="activator"
              icon
              :loading="loading"
              class="mx-0"
              @click="downloadPDF(props.item.id)">
              <v-icon color="orange accent-2">picture_as_pdf</v-icon>
            </v-btn>
            Get PDF invoice
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false" rawHtml />
  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import AppMainDialog from '@/components/AppMainDialog'
  // import resourcesMixins from '@/mixins/Resources'

  export default {
    // mixins: [ resourcesMixins ],
    components: { AppMainDialog },
    data () {
      return {
        tableHeaders: [
          { text: 'Answer ID', value: 'id' },
          { text: 'Form Name', value: 'form_name' },
          { text: 'Created at', value: 'created_at' },
          { text: 'Updated at', value: 'updated_at' },
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        items: [],
        formName: '',
        loading: false,
        dialogOpen: false,
        dialogMessage: ''
      }
    },
    methods: {
      downloadPDF (answersId) {
        let pdf = casesAPI.loadPDF(answersId)

        this.loading = true

        pdf.then(result => {
          this.loading = false

          this.dialogMessage = '<a href="' + result.aws_s3_url + '" target="_blank">' + result.aws_s3_url + '</a>'

          this.dialogOpen = true
        })
      },
      loadListing () {

      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    created () {
      casesAPI.getLinkedAnswers(this.casesid).then(result => {
        let data = result[0].answer
        let dataJson = JSON.parse(data)

        this.formName = dataJson.form_name

        this.items = result
      }, this.loadListingError)
    }
  }
</script>



// WEBPACK FOOTER //
// CaseFormsAnswersDataTable.vue?6e08185a